import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';

@Injectable({ providedIn: 'root' })
export class DeleteTimeOffUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(blockId: string): Observable<void> {
    return this._repository.deleteTimeOff(blockId);
  }
}
